module.exports = __webpack_public_path__ + "static/media/swagger-logo.87d6edcf.png";